<template>
  <batch-upload-file lob="AI" />
</template>

<script>
import batchUploadFile from '@/components/Cargo/FileUpload/batchUploadFile'
export default {
  name: 'AIBatchUploadFile',
  components: { batchUploadFile }
}
</script>

<style scoped>

</style>
